/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { DateTimeFieldDisplay } from "./display";
import { DateTimeFieldEdit } from "./edit";

const DateTimeField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <DateTimeFieldDisplay />,
        editComponent: <DateTimeFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
DateTimeField.displayName = "DateTimeField";
export { DateTimeField };
